module.exports = __webpack_public_path__ + "img/b3-1.84405ef.png";